import { GET_REQ_HISTORY } from '../types';

const initialState = {
  reqHistory: []
};

export default function ReqHistoryReducer(state = initialState, action) {
  switch (action.type) {
    case GET_REQ_HISTORY:
      return {
        ...state,
        reqHistory: action.payload
      };
    default:
      return state;
  }
}
